<app-content-holder Title="Help and Support" Description="" style="width: 100%; min-width: 100%;max-width: 100%;">
  <div style="width: 100%; min-width: 100%;max-width: 100%;">
    For support please call <a href="tel:0161 507 1598">0161 507 1598</a>, or you can <a
      href="mailto:support@activesalon.com?subject=Support Request">email support</a>
  </div>
</app-content-holder>